import * as React from 'react'

import { SelectField, type SelectFieldProps } from '@/components/ui'
import { humanizeText } from '@/utils'

const createOptions = (options: string[] | readonly string[]) => {
  return options
    .map((option) => ({
      label: humanizeText(option),
      value: humanizeText(option),
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}

export interface HumanizedSelectFieldProps
  extends Omit<SelectFieldProps, 'options'> {
  options: string[]
}

const HumanizedSelectField = React.forwardRef<
  HTMLInputElement,
  HumanizedSelectFieldProps
>(({ options, ...props }, ref) => {
  return <SelectField {...props} options={createOptions(options)} ref={ref} />
})
HumanizedSelectField.displayName = 'HumanizedSelectField'

export { HumanizedSelectField }
